/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete'
import FontAwesome from 'react-fontawesome';

import OzComponent from '../../lib/OzComponent';
import { jsonAndStatus, ss, navTo, mapDispatch, urlEncodeQueryFilters } from '../../utils/util';

import './OmniField.css';

import {
  getOmni,
  getSuggestions,
} from '../../actions';

const key = 'AIzaSyDJJtqQb5zqr4GfVw3IKHsFtvUoi34wsuA';


class OmniField extends Component {

  constructor(props) {
    super(props);
    let q = props.q || '';
    this.state = { q: q, index: null };
    this.seq = 1;
  }

  componentDidMount() {
    if (this.props.focusOnMount) {
      this.refs.omni.focus();
    }
  }

  onSelect(address, placeId) {
    console.log('selected:', address);
    this.setState({ name: address });

    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => {
        let where = {
          name: address,
          lat: latLng.lat,
          lng: latLng.lng,
        };
        this.setState(
          where,
          () => this.props.onSelect(where));
      });
  }

  onChange(e, v) {
    if (e.key == 'Escape') {
      console.log('ESCAPE!');
    }
    console.log('the new value is', v);

    let where = { name: v };
    this.setState(where)
    this.setState({ didType: true});
    this.props.onChange(where);
  }

  renderAutocompleteItem(item) {
    let fs = item.formattedSuggestion;
    return (
      <div className="location-ac-item">
        <strong>{fs.mainText}</strong>{' '}
        <small>{fs.secondaryText}</small>
      </div>
    );
  }

  where() {
    let geoIp = this.props.geoIp;
    let where = {};
    if (this.state.name == undefined) {
      where.name = this.props.prefill || '';
    } else {
      where.name = this.state.name;
      where.lat = this.state.lat;
      where.lng = this.state.lng;
    }
    return where;
  }

  select(result) {
    if (this.props.onResult) {
      this.props.onResult(result);
      this.setState({ haveResults: false, q: result.full });
      return;
    }
    let url = null;
    switch (result.type) {
      case 'city':
        url = '/s?city=' + encodeURIComponent(result.full);
        break;
      case 'room':
        console.log('omni room result', result);
        url = '/r/' + result.slug + '/' + result.id;
        break;
      case 'location':
        let query = urlEncodeQueryFilters([{ key: 'company', value: result.company }]);
        url = '/s?city=' + encodeURIComponent(result.cityName) + '&filters=' + query + '&show=rooms';
        break;
    }

    if (url) {
      this.clear();
      navTo('/cl');  // Hack to force remount. TODO: something that's not a hack
      setTimeout(() => navTo(url), 1);
    }
  }

  change(q) {
    this.seq++;
    let seq = this.seq;
    // this.props.getOmni(null, { background: true, silent: true }, { q })
    //   .then(resp => {
    //     if (seq != this.seq) return;
    //     console.log('omni resp', resp);
    //     this.setState({ results: resp.obj.results });
    //   });
    // return;

    if (!q || q == '') {
      this.setState({ q, haveResults: false, index: null });
      return;
    }
    this.setState({ q });

    let service = new google.maps.places.AutocompleteService();
    // let req = new google.maps.places.AutocompletionRequest({
    //   input: q,
    // });
    let req = {
      types: ['(cities)'],
      input: q,
    };
    console.log('req:', req);

    let mapsPromise = new Promise(function(resolve, reject) {
      service.getPlacePredictions(req, resolve);
      // resp => {
      //   console.log('service gave', resp);
      // });
    });

    let suggestionsPromise = this.props.getSuggestions(q, { background: true, silent: true });

    this.setState({ loading: true });

    let groupIds;
    if (this.props.showTypes) {
      groupIds = this.props.showTypes;
    } else {
      groupIds = ['cities', 'rooms', 'locations'];
    }

    let results = [];
    Promise.all([mapsPromise, suggestionsPromise])
      .then(resps => {
        if (seq != this.seq) return;
        this.setState({ loading: false, index: null });

        console.log('all resps', resps);

        let citiesResp = resps[0] || [];
        let suggestionsResp = resps[1];

        let cities = [];
        if (groupIds.includes('cities')) {
          for (let result of citiesResp) {
            cities.push({
              type: 'city',
              id: result.id,
              full: result.description,
              main: result.structured_formatting.main_text,
              secondary: result.structured_formatting.secondary_text,
            });
          }
        }

        let rooms = [];
        if (groupIds.includes('rooms')) {
          rooms = suggestionsResp.obj.rooms.map(room => {
            let main = room.name;
            let parts = [];
            if (room.location) {
              parts.push(room.location.company);
              parts.push(room.location.city.name);
            }
            let secondary = parts.join(', ');
            return {
              type: 'room',
              id: room.id,
              main: main,
              secondary: secondary,
              full: main + ', ' + secondary,

              slug: room.slug,
              roomName: room.name,
              cityName: room.cityName,
            }
          });
        }

        let locations = [];
        if (groupIds.includes('locations')) {
          locations = suggestionsResp.obj.locations.map(location => {
            let main = location.company;
            let secondary = location.cityName;
            return {
              type: 'location',
              id: location.id,
              main: main,
              secondary: secondary,
              full: main + ', ' + secondary,

              company: location.company,
              cityName: location.cityName,
            }
          });
        }

        let results = [].concat(cities).concat(rooms).concat(locations);
        let delta = { haveResults: true, cities, rooms, locations, results };
        this.setState(delta);
      });
  }

  renderResults() {
    if (this.state.loading) {
      return (
        <div className="results">
          Loading...
        </div>
      );
    }

    if (!this.state.haveResults) {
      return;
    }

    // let num = 3;
    let groupIds;
    if (this.props.showTypes) {
      groupIds = this.props.showTypes;
    } else {
      groupIds = ['cities', 'rooms', 'locations'];
    }
    let numWithResults = 0;
    for (let groupId of groupIds) {
      let group = this.state[groupId];
      if (group && group.length) {
        numWithResults++;
      }
    }

    let groupingNodes = [];
    let rowCount = 0;
    for (let groupId of groupIds) {
      let group = this.state[groupId];
      if (!group || !group.length) {
        continue;
      }
      let num = Math.round(10 / numWithResults);
      let groupSpec = {
        cities: { name: 'Cities' },
        rooms: { name: 'Rooms' },
        locations: { name: 'Companies' },
      }
      console.log('Group', group);
      let nodes = group.slice(0, num).map(result => {
        console.log('active?', rowCount, this.state.index);

        let active = rowCount == this.state.index;
        let index = rowCount;
        rowCount++;

        return (
          <div
            key={groupId + ':' + result.id}
            className={cx('result', { active })}
            onClick={() => this.select(result)}
            onMouseOver={() => this.setIndex(index)}
            >
            <div>{result.main}</div>
            <div>{result.secondary}</div>
          </div>
        );
      });
      let groupingNode = (
        <div key={groupId} className="result-category">
          <div className="result-type">{groupSpec[groupId].name}</div>
          <div className="result-nodes">{nodes}</div>
        </div>
      );
      groupingNodes.push(groupingNode);
    }

    return (
      <div className="results">
        {!!this.props.beforeResults && this.props.beforeResults}
        {groupingNodes}
      </div>
    );
  }

  setIndex(index) {
    this.setState({ index });
  }

  moveDown() {
    let index;
    if (this.state.index == null) {
      index = 0;
    } else {
      index = this.state.index + 1;
    }
    this.setState({ index });
  }

  moveUp() {
    let index = this.state.index || 0;
    index--;
    if (index < 0) {
      index = null;
    }
    this.setState({ index });
  }

  trySelectIndex() {
    let index = this.state.index;
    if (index == null) {
      console.log('no index');
      return;
    }

    if (!this.state.haveResults) {
      console.log('no results');
      return;
    }

    if (index >= this.state.results.length) {
      console.log('no results in bounds');
      return;
    }

    // console.log('select from', index, this.state.results);
    let result = this.state.results[index];
    this.select(result);
  }

  keyUp(e) {
    e.preventDefault();
    console.log('key press', e.key);
    switch (e.key) {
      case 'Escape':
        this.setState({ haveResults: false });
        break;

      case 'ArrowDown':
        this.moveDown();
        break;

      case 'ArrowUp':
        this.moveUp();
        break;

      case 'Enter':
        console.log('captured enter');
        this.trySelectIndex();
        break;
    }
  }

  clear() {
    this.setState({ q: '', results: null, haveResults: false, index: null });
  }

  render() {
    let where = this.where();

    console.log('render with where:', where);

    return (
      <div className="OmniField">
        {this.state.q && <div className="clear"><FontAwesome onClick={() => this.clear()} name="times-circle" /></div>}
        <input
          type="text"
          ref="omni"
          value={this.state.q}
          onSubmit={(e) => e.preventDefault()}
          onKeyUp={(e) => this.keyUp(e)}
          onChange={(e) => this.change(e.target.value)}
          placeholder={this.props.prefill || 'Search'}
        />
        {this.renderResults()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getOmni,
    getSuggestions,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OmniField);



/** WEBPACK FOOTER **
 ** ./src/components/partials/OmniField.js
 **/